import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import {
  deleteSiteConstructorQuery,
  fetchSiteConstructorsQuery,
} from 'app/edozvola/cases/construction-participants/service/construction-participants.queries';
import { SiteConstructorView } from 'app/edozvola/cases/construction-participants/model/construction-participants.model';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const SiteConstructorTable = ({ setSiteConstructor, setReadOnly }) => {
  const { id } = useParams<{ id: string }>();
  const [idSiteConstructorToDelete, setIdSiteConstructorToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.SITE_CONSTRUCTORS_TABLE);

  const { mutate: deleteSiteConstructorMutation, isPending: siteConstructorDeletionPending } = deleteSiteConstructorQuery();

  const openDeleteDialog = idToDelete => {
    setIdSiteConstructorToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeSiteConstructor = () => {
    setDeleteModalShown(false);
    deleteSiteConstructorMutation(idSiteConstructorToDelete);
  };

  const openSiteConstructorForm = (idSiteConstructor: number, readOnly: boolean) => {
    setSiteConstructor(idSiteConstructor);
    setReadOnly(readOnly);
  };

  const renderTableRow = (value: SiteConstructorView, siteConstructorIndex: number, totalItems: number) => {
    return (
      <tr key={siteConstructorIndex} className={invalidRowIds.includes(value.idSiteConstructor) ? 'invalid-table-row' : ''}>
        <td>{value.name}</td>
        <td>{value.oibMb}</td>
        <td>{value.address}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon
                  icon={'eye'}
                  className={'icon-table'}
                  onClick={() => openSiteConstructorForm(value.idSiteConstructor, true)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openSiteConstructorForm(value.idSiteConstructor, false)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idSiteConstructor)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema izvođača'}
        initialPaginationColumn={'idSiteConstructor'}
        fetchDataQuery={fetchSiteConstructorsQuery}
        fetchDataProps={id}
      >
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Ime i prezime/Naziv']} width={'13%'}/>
        <ViewTableHeaderColumn renderSort sortKey={'oibMb'} columnLabels={['OIB/MB']} width={'13%'}/>
        <ViewTableHeaderColumn renderSort sortKey={'address'} columnLabels={['Adresa']} width={'13%'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'3%'} />
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje izvođača</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} />
          <Button size={'lg'} label="Obriši" color={'danger'} onClick={removeSiteConstructor} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SiteConstructorTable;
